// Copyright The OpenTelemetry Authors
// SPDX-License-Identifier: Apache-2.0

import Link from 'next/link';
import styled from 'styled-components';

export const Header = styled.header`
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
`;

export const NavBar = styled.nav`
  height: 64px;
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1240px;
  height: 100%;
  margin: 0 auto;
  padding: 0 20px;

  ${({ theme }) => theme.breakpoints.desktop} {
    padding: 0 32px;
  }
`;

export const LeftGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 36px;
`;

export const NavBarBrand = styled(Link)`
  display: flex;
  align-items: center;
  gap: 9px;
  text-decoration: none;
`;

export const BrandLogo = styled.img.attrs({
  src: '/images/opentelemetry-demo-logo.png',
  alt: 'OpenTelemetry demo',
})`
  width: 170px;
  height: auto;
`;

export const NavLinks = styled.div`
  display: none;

  ${({ theme }) => theme.breakpoints.desktop} {
    display: flex;
    align-items: center;
    gap: 24px;
  }
`;

export const NavLink = styled(Link)`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.inkMuted};
  text-decoration: none;
  padding: 4px 0;

  &:hover {
    color: ${({ theme }) => theme.colors.ink};
    box-shadow: inset 0 -2px 0 ${({ theme }) => theme.colors.grafanaOrange};
  }
`;

export const Controls = styled.div`
  display: flex;
  align-items: center;
`;
